@if (formUrl) {
  <div id="iframeContainer" class="flexColumnContainer">
    <iframe id="formPreview" (load)="iframeLoaded()" frameBorder="0" [src]="formUrl | safe"></iframe>
  </div>
}
